import {Request} from "../../core/request";
import {AuthHeader} from "../../core/token";
import type {
    TeacherClass,
    TeacherClassDetail,
    TeacherStudent,
    TeacherGetClassHomeworksRequest,
    TeacherGetClassHomeworksResponse,
    TeacherCreateHomeworkRequest,
    TeacherUpdateHomeworkRequest,
    TeacherHomeworkDetails,
    TeacherHomeworkStatics,
    TeacherHomework,
    TeacherStudentAnswerDetail,
    GradeHomeworkRequest,
    ClassStudentStatsResponse,
} from "./types";

// 获取教师班级列表
export async function getTeacherClasses(): Promise<{data: TeacherClass[]}> {
    const resp = await Request.get(`/teacher/class/`, {
        headers: AuthHeader(),
    });
    return resp.data;
}

// 获取教师班级详情
export async function getTeacherClassDetail(classId: number): Promise<{data: TeacherClassDetail}> {
    const resp = await Request.get(`/teacher/class/${classId}`, {
        headers: AuthHeader(),
    });
    return resp.data;
}

// 获取班级学生列表
export async function getClassStudents(classId: number): Promise<{data: TeacherStudent[]}> {
    const resp = await Request.get(`/teacher/class/${classId}/students`, {
        headers: AuthHeader(),
    });
    return resp.data;
}

// 获取班级作业列表
export async function getTeacherClassHomeworks(classId: number, req: TeacherGetClassHomeworksRequest): Promise<TeacherGetClassHomeworksResponse> {
    const resp = await Request.get(`/teacher/class/${classId}/homeworks`, {
        headers: AuthHeader(),
        params: req,
    });
    return resp.data;
}

// 创建作业
export async function createTeacherHomework(classId: number, req: TeacherCreateHomeworkRequest): Promise<{data: TeacherHomework}> {
    const resp = await Request.post(`/teacher/class/${classId}/homework`, req, {
        headers: AuthHeader(),
    });
    return resp.data;
}

// 更新作业
export async function updateTeacherHomework(classId: number, homeworkID: number, req: TeacherUpdateHomeworkRequest): Promise<{data: TeacherHomework}> {
    const resp = await Request.put(`/teacher/class/${classId}/homework/${homeworkID}`, req, {
        headers: AuthHeader(),
    });
    return resp.data;
}

// 删除作业
export async function deleteTeacherHomework(classId: number, homeworkID: number): Promise<{data: string}> {
    const resp = await Request.delete(`/teacher/class/${classId}/homework/${homeworkID}`, {
        headers: AuthHeader(),
    });
    return resp.data;
}

// 获取作业详情（包含学生成绩）
export async function getTeacherHomeworkDetails(classId: number, homeworkID: number): Promise<{data: TeacherHomeworkDetails}> {
    const resp = await Request.get(`/teacher/class/${classId}/homework/${homeworkID}/details`, {
        headers: AuthHeader(),
    });
    return resp.data;
}

// 获取作业统计
export async function getTeacherHomeworkStatics(classId: number): Promise<{data: TeacherHomeworkStatics}> {
    const resp = await Request.get(`/teacher/class/${classId}/homeworks/statics`, {
        headers: AuthHeader(),
    });
    return resp.data;
}

// 获取班级可下发的作业库（根据老师的subject过滤）
export async function getClassCanUseHomework(classId: number, subjectID: number): Promise<{data: any[]}> {
    const resp = await Request.get(`/teacher/class/${classId}/homeworkBank`, {
        headers: AuthHeader(),
        params: { subjectID },
    });
    return resp.data;
}

// 获取单个学生的作业答案详情
export async function getStudentAnswerDetail(classId: number, homeworkID: number, userId: number): Promise<{data: TeacherStudentAnswerDetail}> {
    const resp = await Request.get(`/teacher/class/${classId}/homework/${homeworkID}/student/${userId}/answer`, {
        headers: AuthHeader(),
    });
    return resp.data;
}

// 老师批改作业
export async function gradeHomework(classId: number, homeworkID: number, answerId: number, req: GradeHomeworkRequest): Promise<{data: any}> {
    const resp = await Request.post(`/teacher/class/${classId}/homework/${homeworkID}/grade/${answerId}`, req, {
        headers: AuthHeader(),
    });
    return resp.data;
}

// 待批改项
export type PendingGradingItem = {
    class_id: number;
    class_name: string;
    homework_id: number;
    homework_name: string;
    pending_count: number;
};

// 获取待批改作业列表
export async function getPendingGrading(): Promise<{data: PendingGradingItem[]}> {
    const resp = await Request.get(`/teacher/grade/pending`, {
        headers: AuthHeader(),
    });
    return resp.data;
}

// 获取班级待批改作业列表
export async function getClassPendingGrading(classId: number): Promise<{data: PendingGradingItem[]}> {
    const resp = await Request.get(`/teacher/class/${classId}/grade/pending`, {
        headers: AuthHeader(),
    });
    return resp.data;
}

// 获取班级学生作业统计（用于排名和图表）
export async function getClassStudentStats(classId: number): Promise<{data: ClassStudentStatsResponse}> {
    const resp = await Request.get(`/teacher/class/${classId}/students/stats`, {
        headers: AuthHeader(),
    });
    return resp.data;
}
